import sarah from './images/Sarah.jpg';
import adel from './images/Adel.jpg'
import tony from './images/tony3.jpg'
import mark from './images/Mark.jpg'
import mash from './images/Mash.jpg'
import rishab from './images/Rishab.jpg'
import sakshi from './images/sakshi.jpg'

export const leader = {
    name: 'Adel Choudria',
    role: 'Data Scientist',
    pic: adel,
    education: '',
    github: 'https://github.com/AdelRCh',
    linkdin: 'https://www.linkedin.com/in/adel-chouadria/',
    devpost: 'https://devpost.com/adelchouadria'
};

export const profileData = [
    
   
    {
        name: 'Sarah Armstrong',
        role: 'Data Science-Statistics',
        pic: sarah,
        education: '"Good At Math"',
        github: 'https://github.com/saraharmstrong314',
        linkdin: 'https://www.linkedin.com/in/saraharmstrong314/',
        devpost: 'https://devpost.com/saraharmstrong314'
    },
    // {
    //     name: 'Mark Artyukh',
    //     role: 'Machine Learning',
    //     pic: mark,
    //     education: '',
    //     github: 'https://github.com/kramiusmaximus',
    //     linkdin: 'https://www.linkedin.com/in/markartyukh/',
    //     devpost: 'https://devpost.com/kramiusmaximus'
    // },
    {
        name: 'Mashiour Rahman',
        role: 'UI Architect',
        pic: mash,
        education: '"Average LOL Player"',
        github: 'https://github.com/mashiourcse',
        linkdin: 'https://www.linkedin.com/in/mashiour-rahman-557b6a16b/',
        devpost: 'https://devpost.com/mashiourcse'
    },
    {
        name: 'Adel Choudria',
        role: `Data Scientist`,
        pic: adel,
        education: '"Interviewed Jankos"',
        github: '',
        linkdin: 'https://www.linkedin.com/in/adel-chouadria/',
        devpost: 'https://devpost.com/adelchouadria'
    },
    {
        name: 'Tianyi HE',
        role: 'Data Analyst',
        pic: tony,
        education: '"Worked With Doinb"',
        github: '',
        linkdin: '',
        devpost: 'https://devpost.com/tony1223010910'
    },
    
    
    {
        name: 'Sakshi Agarwal',
        role: 'AWS Backend Expert',
        pic: sakshi,
        education: '"Infosys Dev"',
        github: 'https://github.com/sakshi360',
        linkdin: 'https://www.linkedin.com/in/sakshi-agarwal-27404913a/',
        devpost: 'https://devpost.com/agarwal-sakshi360'
    },
    
    {
        name: 'Rishab Saxena',
        role: 'AWS Sagemaker',
        pic: rishab,
        education: '"Sagemaker"',
        github: '',
        linkdin: 'https://www.linkedin.com/in/saxena-rishabh/',
        devpost: 'https://devpost.com/saxenarishabh100'
    },
  ]